'use strict';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/observable/from';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import {epicErrorHandler} from '../../../core-utilities/rx-utils';
import {
  assignAssetProjectToModel,
  assignAssetToModel,
  assignOrganizationProfileToModel,
  assignOrganizationToModel,
  assignProjectToModel,
  hydrateAsset,
  hydrateOrganization,
  hydrateProject,
} from '../actions';
import {logger} from './logger';

export const epics = [
  onHydrateOrganization,
  onHydrateProject,
  onHydrateAsset,
];

onHydrateOrganization.$inject = onHydrateProject.$inject = onHydrateAsset.$inject = [
  'PersonDomain',
  'OrganizationDomain',
  'AssetDomain',
  'AssetProjectDomain',
  'ProjectDomain',
];

export function onHydrateOrganization(action$, store, dependencies) {
  return action$.ofType(hydrateOrganization.TYPE)
    .switchMap(action => {
      const PersonDomain = dependencies.PersonDomain;
      const OrganizationDomain = dependencies.OrganizationDomain;
      const ProjectDomain = dependencies.ProjectDomain;
      const AssetProjectDomain = dependencies.AssetProjectDomain;
      const AssetDomain = dependencies.AssetDomain;
      const userId = action.payload.userId;
      const nextOrgId = action.payload.nextOrgId;
      const nextPrjId = action.payload.nextPrjId;
      const nextAstId = action.payload.nextAstId;
      const nextAstPrjId = action.payload.nextAssetProjectId;
      const resolveNull = Promise.resolve(null);
      const getState = Promise.props({
        organization: nextOrgId ? OrganizationDomain.$get(nextOrgId) : resolveNull,
        orgProfile: userId && nextOrgId ? PersonDomain.getOrganizationProfile(userId, nextOrgId) : resolveNull,
        project: nextPrjId ? ProjectDomain.$get(nextPrjId) : resolveNull,
        asset: nextAstId ? AssetDomain.$get(nextAstId) : resolveNull,
        assetProject: nextAstPrjId ? AssetProjectDomain.$get(nextAstPrjId) : resolveNull,
      });

      bindDeferred(getState, action.payload.deferred);

      return getState;
    })
    /* Split the assigned data into separate actions to be dispatched */
    .switchMap((data) =>
      Observable.from([
        assignOrganizationToModel(data.organization),
        assignOrganizationProfileToModel(data.orgProfile),
        assignProjectToModel(data.project),
        assignAssetToModel(data.asset),
        assignAssetProjectToModel(data.assetProject),
      ])
    )
    .catch(epicErrorHandler(logger, 'onHydrateOrganization'));
}

export function onHydrateProject(action$, store, dependencies) {
  return action$.ofType(hydrateProject.TYPE)
    .switchMap(action => {
      const nextPrjId = action.payload.nextPrjId;
      const nextAstId = action.payload.nextAstId;
      const nextAstPrjId = action.payload.nextAssetProjectId;
      const resolveNull = Promise.resolve(null);
      const getState = Promise.props({
        project: nextPrjId ? dependencies.ProjectDomain.$get(nextPrjId) : resolveNull,
        asset: nextAstId ? dependencies.AssetDomain.$get(nextAstId) : resolveNull,
        assetProject: nextAstPrjId ? dependencies.AssetProjectDomain.$get(nextAstPrjId) : resolveNull,
      });

      bindDeferred(getState, action.payload.deferred);

      return getState;
    })
    /* Split the assigned data into separate actions to be dispatched */
    .switchMap((data) =>
      Observable.from([
        assignProjectToModel(data.project),
        assignAssetToModel(data.asset),
        assignAssetProjectToModel(data.assetProject),
      ])
    )
    .catch(epicErrorHandler(logger, 'onHydrateProject'));
}

export function onHydrateAsset(action$, store, dependencies) {
  return action$.ofType(hydrateAsset.TYPE)
    .switchMap(action => {
      const nextAstId = action.payload.nextAstId;
      const nextAstPrjId = action.payload.nextAssetProjectId;
      const resolveNull = Promise.resolve(null);
      const getState = Promise.props({
        asset: nextAstId ? dependencies.AssetDomain.$get(nextAstId) : resolveNull,
        assetProject: nextAstPrjId ? dependencies.AssetProjectDomain.$get(nextAstPrjId) : resolveNull,
      });

      bindDeferred(getState, action.payload.deferred);

      return getState;
    })
    /* Split the assigned data into separate actions to be dispatched */
    .switchMap((data) =>
      Observable.from([
        assignAssetToModel(data.asset),
        assignAssetProjectToModel(data.assetProject),
      ])
    )
    .catch(epicErrorHandler(logger, 'onHydrateAsset'));
}

// Legacy hook
function bindDeferred(promise, deferred) {
  if (deferred) {
    promise.then(deferred.resolve.bind(deferred), deferred.reject.bind(deferred));
  }
}



// WEBPACK FOOTER //
// ./src/js/app/model/epics/hydrateModel.js